/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .directive('accSelectedNodeActions', [
        '$location',
        '$route',
        '$translate',
        'CreateUpdatePublicFolderLinkModal',
        'nodeMembersModal',
        'nodeModalAction',
        'nodeMoveModal',
        'nodeRevisionsModal',
        'OfficeOnline',
        'purgeAllRevisions',
        'Session',
        'SignFile',
        'template',
        'uploadRequestLinkModal',
        'UploadRequestCreateUpdateModal',
        function (
            $location,
            $route,
            $translate,
            CreateUpdatePublicFolderLinkModal,
            nodeMembersModal,
            nodeModalAction,
            nodeMoveModal,
            nodeRevisionsModal,
            OfficeOnline,
            purgeAllRevisions,
            Session,
            SignFile,
            template,
            uploadRequestLinkModal,
            UploadRequestCreateUpdateModal
        ) {
            return {
                scope: {
                    node: '=',
                    currentNode: '=',
                    basePath: '<',
                    searchMode: '<'
                },
                replace: true,
                templateUrl: template('nodes/_selected_node_actions'),
                controller: ['$scope', function ($scope) {
                    $scope.account = Session.account;
                    $scope.settings = Session.settings;

                    $scope.openRevisionsDialog = function () {
                        nodeRevisionsModal($scope);
                    };

                    $scope.openEditFileDialog = function () {
                        OfficeOnline.openFullscreen($scope.node, 'edit');
                    };

                    $scope.openMembersDialog = function () {
                        nodeMembersModal($scope);
                    };

                    $scope.openMoveDialog = function () {
                        nodeMoveModal($scope);
                    };

                    $scope.openCopyDialog = function () {
                        nodeModalAction($scope, {
                            modalController: "CopyMoveController",
                            modalType: "confirm",
                            modalAction: "copy",
                            modalBodyTemplate: "modals/actions/transfer",
                            modalFooterTemplate: "nodes/_transfer_modal_footer",
                            modalTitle: 'Copy',
                            modalActionButton: $translate.instant('Copy'),
                            modalNotifications: true
                        });
                    };

                    $scope.viewInFolder = function () {
                        var
                            parentUuid = $scope.node['parent_uuid'],
                            path = $scope.basePath.replace('#', '/') + '/' + parentUuid;

                        $location.path(path).search({ highlight: $scope.node['name'] });

                        if (parentUuid === $scope.currentNode['uuid']) {
                            // we're already in this folder, let's reload
                            $route.reload();
                        }
                    };

                    $scope.purgeAllRevisions = function () {
                        purgeAllRevisions([$scope.node]);
                    };

                    $scope.sign = function () {
                        SignFile($scope.node);
                    };

                    $scope.sendUploadRequest = function () {
                        if (angular.isUndefined($scope.node.parents)) {
                            var parents = $scope.currentNode.parents.slice(0);
                            parents.push({ name: $scope.node.name });

                            $scope.node.parents = parents;
                        }

                        UploadRequestCreateUpdateModal($scope.node)
                            .then(function (uploadRequest) {
                                uploadRequestLinkModal(uploadRequest);
                            });
                    };

                    $scope.createUpdatePublicLink = function () {
                        CreateUpdatePublicFolderLinkModal($scope.node);
                    };
                }]
            };
        }
    ]);
